export * from 'core/config'

export const merchCategories = ['abbigliamento', 'maglieria', 'accessori', 'calzature', 'pelletteria']
